import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=2ec8f235&scoped=true&"
import script from "./NotFound.vue?vue&type=script&lang=js&"
export * from "./NotFound.vue?vue&type=script&lang=js&"
import style0 from "./NotFound.vue?vue&type=style&index=0&id=2ec8f235&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../DATA/projects/nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec8f235",
  null
  
)

export default component.exports